module.exports = __webpack_public_path__ + "img/p8_8.e9130149.png";